import { render, staticRenderFns } from "./PrizeDetail.vue?vue&type=template&id=3a8dbb28&scoped=true"
import script from "./PrizeDetail.vue?vue&type=script&lang=js"
export * from "./PrizeDetail.vue?vue&type=script&lang=js"
import style0 from "./PrizeDetail.vue?vue&type=style&index=0&id=3a8dbb28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8dbb28",
  null
  
)

export default component.exports